export default __webpack_public_path__ + "static/media/Twoface.6f884d98.png";